export default {
  title: 'Product Attributes',
  addFirstLevel: 'Add Attribute Group',
  addSecondLevel: 'Add Attribute',
  attributeName: 'Attribute Name',
  addModal: 'Add Attribute Group',
  addSecondModal: 'Add Attribute',
  editModal: 'Edit Attribute',
  required: 'Please enter attribute name',
};
